/* Only product handles and visit times are stored, after the shopper opts in. */
(() => {
  const ttl = 30 * 24 * 60 * 60 * 1000;
  const validHandle = value => typeof value === 'string' && /^amazon-[a-z0-9]{10}$/.test(value);
  const normalize = (input, now = Date.now()) => {
    const seen = new Set();
    const items = (Array.isArray(input?.items) ? input.items : [])
      .filter(item => validHandle(item?.handle) && Number.isFinite(item.time) && item.time <= now && item.time > now - ttl)
      .sort((a, b) => b.time - a.time)
      .filter(item => !seen.has(item.handle) && seen.add(item.handle))
      .slice(0, 30).map(({handle, time}) => ({handle, time}));
    return {enabled: input?.enabled === true, items};
  };
  const visit = (input, handle, now = Date.now()) => {
    const clean = normalize(input, now);
    if (!clean.enabled || !validHandle(handle)) return clean;
    return normalize({enabled: true, items: [{handle, time: now}, ...clean.items.filter(item => item.handle !== handle)]}, now);
  };
  window.BizedealsMemberHistory = {normalize, visit, validHandle};
})();
